import { render, staticRenderFns } from "./CompanyMobileReserved.vue?vue&type=template&id=385207c2"
import script from "./CompanyMobileReserved.vue?vue&type=script&lang=js"
export * from "./CompanyMobileReserved.vue?vue&type=script&lang=js"
import style0 from "./CompanyMobileReserved.vue?vue&type=style&index=0&id=385207c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports